import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs/operators';

import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { EchoService } from '@teem/services/echo.service';
import { AddCityModalComponent } from '@teem/layouts/models/add-city-modal/add-city-modal.component';
import { AddStoreTypeModalComponent } from '@teem/layouts/models/add-store-type-modal/add-store-type-modal.component';
import { FreePlanExpiredModalComponent } from '@teem/layouts/models/free-plan-expired/free-plan-expired-modal.component';
import { TapIncreaseConsentModalComponent } from '@teem/layouts/models/tap-increase-consent/tap-increase-consent-modal.component';
import { OrderPlacedModalComponent } from './models/order-placed-modal/order-placed-modal.component';

@Component({
	selector: 'app-main-layout',
	templateUrl: './main-layout.component.html'
})
export class MainLayoutComponent implements OnInit {
	public user: any;
	public hideAlertMessage: boolean = false;
	public permissions: any = null;
	public echo: any;
	public addBgWhiteClass: boolean = false;
	public addNormalPaddingStyle: boolean = false;
	public isInvoiceListing: boolean = false;
	public isCreateInvoice: boolean = false;
	public isStorePage: boolean = false;
	public isQuatationListing: boolean = false;
	public isPaymentPage: boolean = false;
	public isReportListing: boolean = false;
	public notifications: Array<any> = [];
	public unreadNotificationsCount: number = 0;
	public notificationAlertEnabled: boolean = false;
	public isPopUpOpened: boolean = false;
	public isStoreModalIsOpened: boolean = false;
	public isSelectPricingPlan: boolean = false;
	private audio : any = '';
	constructor(
		private router: Router,
		private modalService: NgbModal,
		private userService: UserService,
		private echoService: EchoService,
		private sharedDataService: SharedDataService
	) {
		this.checkIsSettingPage();
		// this.audio = new Audio(`${window.location.origin}/audio/flute.wav`);
		this.audio = new Audio(`${window.location.origin}/audio/flute_v1.wav`);
	}

	ngOnInit(): void {
		this.echo = this.echoService.getEcho();

		this.userService.getUserBasicInfo().subscribe((data: any) => {
			this.user = data;

			this.sharedDataService.setItem('userInfo', this.user);

			if (data.permissions) {
				this.permissions = data.permissions;
				this.sharedDataService.setItem('permissions', data.permissions);
			}

			if (!this.user?.is_agreement_accept) {
				this.openTapIncreaseConsentModal();
			}

			if (this.user && (!this.user.store_type || !this.user.phone || !this.user.business_name )) {
				this.openAddStoreTypeModal();
			}
			
			// if (this.user && !this.user.city) {
			// 	this.openAddCityModal();
			// }

			if ((this.user?.subscription?.original_subscription_plan == 'free') && (this.user?.subscription?.subscription_plan == 'free') && (!this.isSelectPricingPlan)) {
				this.openExpireFreeTrial();
			}
			
			this.subscribeNotifications();
		});

		this.userService.getNotifications().subscribe((data: any) => {
			this.notifications = data.notifications ? data.notifications : [];
			this.unreadNotificationsCount = data.notifications ? data.unread_count : 0;
		});

		this.sharedDataService.asObservable().subscribe((data) => {
			if (data && data.userInfo) {
				this.user = data.userInfo;
			}

			if (data && data.permissions) {
				this.permissions = data.permissions;
				this.user.permissions = data.permissions;
			}
		});

	}

	subscribeNotifications() {
		this.echo.private(`App.User.${this.user.id}`)
			.notification((e) => {
				switch (e.type) {
					case 'App\\Notifications\\OrderPlacedNotification':
					this.openOrderModal(e);
					break;

					default:
					this.defaultNotificationAction(e);
					break;
				}
			});
		
		this.echo.private(`App.User.${this.user.id}`)
			.listen('.OrderPlaced', (e) => {
				if (e.type === 'order-placed') {
					this.openOrderModal(e);
				}
			});

		this.askNotificationPermission();
	}

	playSound(): void {
		this.audio.play().catch(err => {
			console.warn('Audio playback failed:', err);
		});
	}

	stopSound(): void {
		this.audio.pause();
		this.audio.currentTime = 0;
	}

	openOrderModal(e) {
		this.playSound();
		const ngbModalOptions: NgbModalOptions = {
			backdrop: 'static',
			keyboard: false
		};

		const modalRef = this.modalService.open(OrderPlacedModalComponent, ngbModalOptions);
		modalRef.componentInstance.message = e.message;
		modalRef.componentInstance.orderId = e.order_id;
		modalRef.componentInstance.isAutoAccept = e.isAutoAccept;

		modalRef.result.then(data => {
			this.stopSound()
		}, fallbackResult => {
			this.stopSound()
		})
	}

	defaultNotificationAction(e){
		this.notifications.unshift({
			id: e.id,
			message: e.message,
			is_read: false
		});

		this.unreadNotificationsCount++;

		try {
			this.notify(e.message);
		} catch (err) {
			console.error(err);
		}

		if (e.reload) {
			(window as any).location.reload();
		}
	}

	askNotificationPermission() {
		// Let's check if the browser supports notifications
		if (!("Notification" in window)) {
			return;
		}

		// Let's check whether notification permissions have already been granted
		if (Notification.permission !== "granted") {
			// If it's okay let's create a notification
			Notification.requestPermission().then((permission) => {
				if (permission === "granted") {
					this.notificationAlertEnabled = true;
					this.notify('Notification Enabled for Teem-App');
				}
			});
		}
	}

	notify(msg) {
		if (Notification.permission === "granted") {

			// Remove html tags from msg
			try {
				msg = msg.toString();
				msg = msg.replace(/(<([^>]+)>)/ig, '');
			} catch (err) {
				console.error(err);
			}

			var notification = new Notification(msg);
		}
	}

	ngAfterViewInit() {
		document.getElementById('page-footer').classList.remove('d-none');

		// if (navigator.userAgent.match(/Android/i)
		//     || navigator.userAgent.match(/webOS/i)
		//     || navigator.userAgent.match(/iPhone/i)
		//     || navigator.userAgent.match(/iPad/i)
		//     || navigator.userAgent.match(/iPod/i)
		//     || navigator.userAgent.match(/BlackBerry/i)
		//     || navigator.userAgent.match(/Windows Phone/i)) {

		//     Swal.fire({
		//       text: "This tool is best viewed using desktop.",
		//       confirmButtonText: 'Continue with mobile',
		//       customClass: {
		//         confirmButton: 'btn btn-outline-warning text-warning',
		//       },
		//       backdrop: `linear-gradient(114deg, rgba(12,197,209,0.8), rgba(28,106,182,0.8))`,
		//       buttonsStyling: false
		//     });

		// }
	}

	get pendingInvoiceCount() {
		return this.permissions && this.permissions.pending_invoices ? this.permissions.pending_invoices : 0;
	}

	navigateToPlans() {
		this.router.navigate(['/setting'], { queryParams: { 'tab': 'plans' } });
	}

	viewNotification(msg: any) {
		if (!msg.is_read) {
			this.unreadNotificationsCount--;
			msg.is_read = true;

			this.userService.readNotification(msg.id).subscribe((r) => {
				// cosole.log()
			});
		}

		if (msg.link) {
			this.router.navigate([msg.link]);
		}
	}

	checkIsSettingPage() {
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(res => {
			if (this.router.url.includes("/setting") || this.router.url.includes("/dashboard") || this.router.url.includes("/clients") || this.router.url.includes("/zatca"))
				this.addBgWhiteClass = true,
				this.addNormalPaddingStyle = true;
			else
				this.addBgWhiteClass = false,
				this.addNormalPaddingStyle = false;
			if (this.router.url.includes("/subscription-plan"))
				this.isSelectPricingPlan = true;
			if (this.router.url.includes("/invoices"))
				this.isInvoiceListing = true;
			else
				this.isInvoiceListing = false;
			if (this.router.url.includes("/store"))
				this.isStorePage = true;
			else
				this.isStorePage = false;				
			if (this.router.url.includes("/quotations"))
				this.isQuatationListing = true;
			else
				this.isQuatationListing = false;				
			if (this.router.url.includes("/payments") || this.router.url.includes("/payments"))
				this.isPaymentPage = true;
			else
        		this.isPaymentPage = false;
			if (this.router.url.includes("/create-invoice"))
				this.isCreateInvoice = true;
			else
				this.isCreateInvoice = false;
		});

	}

	openExpireFreeTrial() {
		
		let ngbModalOptions: NgbModalOptions = {
			backdrop: 'static',
			keyboard: false
		};
		const modalRef = this.modalService.open(FreePlanExpiredModalComponent, ngbModalOptions);
		// Set id on modal dialog
		modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "expired-modal";
		modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.classList.add('expired-modal');
		modalRef.componentInstance.userInfo = this.user;

		modalRef.result.then(data => {
		
		}, fallbackResult => {
		// do nothing
		})
			
		
	}


	openAddCityModal() {
		if (!this.isPopUpOpened) {
			this.isPopUpOpened = true;
			let ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				keyboard: false
			};
			const modalRef = this.modalService.open(AddCityModalComponent, ngbModalOptions);
			// Set id on modal dialog
			modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "addcity";
			modalRef.componentInstance.userInfo = this.user;

			modalRef.result.then(data => {
				let user = this.sharedDataService.getItem('userInfo');
				Object.assign(user, data);
				Object.assign((window as any).userInfo, data);
				this.sharedDataService.setItem('userInfo', user);

			}, fallbackResult => {
				// do nothing
			})
		}

	}

	openAddStoreTypeModal() {
		if (!this.isStoreModalIsOpened) {
			this.isStoreModalIsOpened = true;
			let ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				keyboard: false
			};
			const modalRef = this.modalService.open(AddStoreTypeModalComponent, ngbModalOptions);
			// Set id on modal dialog
			modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "addcity";
			modalRef.componentInstance.userInfo = this.user;

			modalRef.result.then(data => {
				let user = this.sharedDataService.getItem('userInfo');
				Object.assign(user, data);
				Object.assign((window as any).userInfo, data);
				this.sharedDataService.setItem('userInfo', user);

			}, fallbackResult => {
				// do nothing
			})
		}

	}

	openTapIncreaseConsentModal() {		
		let ngbModalOptions: NgbModalOptions = {
			backdrop: 'static',
			keyboard: false
		};
		const modalRef = this.modalService.open(TapIncreaseConsentModalComponent, ngbModalOptions);
		// Set id on modal dialog
		modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "addcity";
		modalRef.componentInstance.userInfo = this.user;

		modalRef.result.then(data => {
		
		}, fallbackResult => {
		// do nothing
		});
	}
}
